module.exports = __webpack_public_path__ + "img/popup-absences.15d4f7aa.png";